import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';

const {
  addRequestError,
  addPartners,
  startRequest,
  endRequest
} = actions;

const {
  API_PARTNERS,
  LOAD_PARTNERS_SAGA
} = constants;

const apiLoadAdminPartners = () => (
  axios.get(API_PARTNERS)
);

function* loadPartners({ }) {
  try {
    yield put(startRequest('loading_partners'));

    const response = yield call(apiLoadAdminPartners);
    const partners = response.data.partnerships;

    yield put(addPartners(partners));
    yield put(endRequest('loading_partners'));

  } catch (e) {
    yield put(addRequestError(e.response))
    yield put(endRequest('loading_partners'));
  }
}

function* __loadPartnersSaga() {
  yield takeEvery(LOAD_PARTNERS_SAGA, loadPartners)
}

export {
  __loadPartnersSaga
};



// WEBPACK FOOTER //
// ./src/sagas/partners.js